import { get } from '../request.js';

/**
 * 获取时间枚举
 */
export async function queryDateConfig(params) {
  return get('/api/analysis/basic/range_cfg', params);
}
/**
 * 会员概览
 */
export async function queryMemberOverviews(params) {
  return get('/api/analysis/overviews/member_overviews', params);
}
/**
 * 会员图表
 */
export async function queryMemberChartData(params) {
  return get('/api/analysis/overviews/member_overviews_picture', params);
}
/**
 * 会员画像概览
 */
export async function queryMemberProfileOverviews(params) {
  return get('/api/analysis/overviews/member_profile_overviews', params);
}
/**
 * 会员年龄分析
 */

export async function queryMemberProfileAge(params) {
  return get('/api/analysis/overviews/member_age', params);
}
/**
 * 会员性别分析
 */
export async function queryMemberProfileGender(params) {
  return get('/api/analysis/overviews/member_gender', params);
}
/**
 * 会员会龄分布
 */
export async function queryMemberProfileMemberRegistration(params) {
  return get('/api/analysis/overviews/member_registration', params);
}
/**
 * 会员折扣敏感度
 */
export async function queryMemberProfileMemberPromotion(params) {
  return get('/api/analysis/overviews/member_promotion', params);
}
/**
 * 会员地区分布图
 */
export async function queryMemberProfileMemberMap(params) {
  return get('/api/analysis/overviews/member_consumption_map', params);
}
/**
 * RFM
 */
export async function queryRFM(params) {
  return get('/api/analysis/overviews/member_rfm', params);
}
/**
 * RFM
 */
export async function queryRFMScore(params) {
  return get('/api/analysis/overviews/member_rfm_score', params);
}
/**
 * 会员生命周期
 */
export async function queryMemberLifecycle(params) {
  return get('/api/analysis/overviews/member_lifecycle', params);
}